var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-label',{staticClass:"label-small",attrs:{"text":_vm.statusLabel.label,"color":_vm.color,"outlined":_vm.statusLabel.outlined}})}
var staticRenderFns = []

export { render, staticRenderFns }